import styled from 'styled-components';

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 30px;
  width: 600px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-family: 'Inter', sans-serif;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 10px 0;
`;

export const Subtitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 30px 0;
`;

export const TableTitle = styled.h4`
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
`;

export const Th = styled.th`
  padding: 12px 8px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    text-align: center;
  }
  
  &:nth-child(2) {
    text-align: left;
  }
`;

export const Td = styled.td`
  padding: 12px 8px;
  text-align: center;
  font-size: 13px;
  color: #666;
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    text-align: center;
  }

  &:nth-child(2) {
    text-align: left;
  }
`;

export const CheckboxInput = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #0090d3;
`;

export const QtdInput = styled.input`
  width: 60px;
  padding: 6px;
  text-align: center;
  border: 1px solid #d0d0d0;
  border-radius: 100px;
  background-color: transparent;
  color: #333;
  font-size: 13px;

  /* Hide arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  background: none;
  border: 1px solid #0090d3;
  color: #0090d3;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
`;

export const ConfirmButton = styled.button`
  background-color: #0090d3;
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
